<script setup lang="ts">
import VisualFailure from './VisualFailure.vue';
import ButtonPrimary from '@/shared/components/button/ButtonPrimary.vue';

withDefaults(
  defineProps<{
    title: string;
    showRetryButton?: boolean;
    retryButtonLabel?: string;
    retryButtonExtraTopMargin?: boolean;
    retryButtonDataTestId?: string;
  }>(),
  {
    title: 'Failed to load data',
    showRetryButton: true,
    retryButtonLabel: "Let's try again",
    retryButtonExtraTopMargin: false,
    retryButtonDataTestId: 'retry-btn',
  },
);

const emit = defineEmits<{
  (e: 'onRetry'): void;
}>();

const onRetry = () => {
  emit('onRetry');
};
</script>

<template>
  <div class="page-failure-container">
    <VisualFailure>
      <template #title>{{ title }}</template>
    </VisualFailure>
    <p>
      Please try again.
      <span class="error-message-note"> If the problem persists, please contact Allume. </span>
    </p>
  </div>
  <div
    v-if="showRetryButton"
    :class="['end-of-page', { 'end-of-page--extra-top-margin': retryButtonExtraTopMargin }]"
  >
    <ButtonPrimary block @click="onRetry" :data-tn="retryButtonDataTestId">
      {{ retryButtonLabel }}
    </ButtonPrimary>
  </div>
</template>

<style lang="less" scoped>
.page-failure-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: @content-side-margin;

  .error-message-note {
    display: block;
    margin-top: 0.5rem;
  }
}
.end-of-page {
  width: 100%;
  padding: @content-side-margin;

  &--extra-top-margin {
    margin-top: @margin-top-end-of-page-section;
  }
}
</style>